import { Component, OnInit } from '@angular/core';
import {Subject} from 'rxjs';
import { ReservationPluginInfo } from 'projects/qcloud-models/reservation-plugin/reservation-plugin-info';
import { TicketReservationPlugin } from 'projects/qcloud-models/reservation-plugin/ticket-reservation-plugin';
import { ReservationPluginService } from '../../services/reservation-plugin.service';
import { TicketReservationService } from '../../services/ticket-reservation.service';

@Component({
  selector: 'app-reservation-form',
  templateUrl: './reservation-form.component.html',
  styleUrls: ['./reservation-form.component.scss']
})
export class ReservationFormComponent implements OnInit {
  triggerResetTimer: Subject<boolean> = new Subject();
  ticketReservation = new TicketReservationPlugin();
  reservationInfo: ReservationPluginInfo;
  formInvalid: boolean;
  termsChecked: boolean;
  showConfirmation: boolean;
  showTerms = false;
  selectedCategoryName = "";

  constructor(private ticketReservationService: TicketReservationService, public service: ReservationPluginService) {
    ticketReservationService.ticketReservation.subscribe((val: TicketReservationPlugin) => {
      this.ticketReservation = val;
      this.setSelectedCategoryName();
    });
  }

  ngOnInit(): void {
    this.service.getReservationData().subscribe(
      data => {
        this.reservationInfo = data;
        this.service.publishReservationInfo(data);
        this.service.setRecaptchaKey(data.configuration.recaptchaPublicKey);
        this.showConfirmation = !this.reservationInfo.configuration.twoStepVerification;
        this.getReservationConfirmation();
      }
    );
  }

  checkReservationPageVisibility() {
    return this.reservationInfo.isPluginActive;
  }

  getReservationConfirmation() {
    const url = new URL(window.location.href);
    const queryString = url.hash.split('?')[1]; // get part after "?"
    const queryParams = new URLSearchParams(queryString);
    const reservationGuid = queryParams.get('guid');
    if (reservationGuid) {
      this.service.getReservation(reservationGuid).subscribe(
        (res) => {
          this.ticketReservation = res;
          this.showConfirmation = true;
          this.setSelectedCategoryName();
        }
      );
    }
  }

  setSelectedCategoryName() {
    let category = this.reservationInfo.categories.find(x => x.id == this.ticketReservation.categoryId);
    if (category) {
      this.selectedCategoryName = category.fullName;
    }
  }

  checkForm(event: boolean) {
    this.formInvalid = event;
  }

  resetTimer(){
    this.triggerResetTimer.next(true);
  }

}
